import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom"
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import moment from "moment";
import CommonValues from "../common/utils";
import axios from "axios";
import { Toast } from "primereact/toast";
import Header from "../common/Header";
import BackgroundVideo from "../common/BackgroundVideo";
import BillingMiddleHeader from "./BillingMiddleHeader";
import BillingSidebar from "./BillingSidebar";
import AtkTextField from "../AtlaskitControls/AtkTextField";
import { Dropdown } from "primereact/dropdown";
import AtkLoader from "../AtlaskitControls/AtkLoader";

export default function CostTrackingPage() {
    const navigate = useNavigate();
    const toast: any = useRef("");
    const [costTrackingList, setCostTrackingList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [toolNameSearch, setToolNameSearch] = useState("");
    const [fromDate, setFromDate] = useState<Date | null>((moment().subtract(1, "months").toDate()));
    const [toDate, setToDate] = useState<Date | null>(moment().toDate());
    const toolsNameList = [
        { label: "Acord And Dec Pages Scan", value: "Acord And Dec Pages Scan" },
        { label: "Certificate Of Insurance", value: "Certificate Of Insurance" },
        { label: "Commission Scan", value: "Commission Scan" },
        { label: "Driver License Scan", value: "Driver License Scan" },
        { label: "Invoice Scan", value: "Invoice Scan" },
        // { label: "Create New COI Certificate", value: "Create New COI Certificate" },
        { label: "Data Enrichment", value: "Data Enrichment" },
        { label: "Vehicle Prefill", value: "Vehicle Prefill" },
        { label: "MTM Scan", value: "MTM Scan" },
        { label: "MVR", value: "MVR" },
    ]
    useEffect(() => {
        getUserCostTracking();
    }, [])

    const getUserCostTracking = () => {
        setLoading(true);
        var token = CommonValues.GetToken();
        var config = {
            method: "get",
            url: `${process.env.REACT_APP_UserService_Url}/api/user/costtrack`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        axios(config)
            .then((response: any) => {
                setCostTrackingList(response.data);
                setLoading(false);
            })
            .catch((error: any) => {
                let errorMessage = "";
                setLoading(false);
                if (error.response != null) {
                    if (error.response.status == 401) {
                        navigate("/");
                        CommonValues.Logout(navigate);
                    } else {
                        errorMessage = "Unknown error while loading the user cost tracking";
                        toast.current.show({
                            severity: "error",
                            summary: "Error",
                            detail: errorMessage,
                            life: 3000,
                        });
                    }
                } else {
                    errorMessage = "Unknown error while loading the user cost tracking";
                    toast.current.show({
                        severity: "error",
                        summary: "Error",
                        detail: errorMessage,
                        life: 3000,
                    });
                }
            });
    };

    const filteredList = costTrackingList.filter((item: any) => {

        const isAll = toolNameSearch === "All" || toolNameSearch === "";
        const toolNameMatch = isAll || item.toolName?.toLowerCase().includes(toolNameSearch.toLowerCase());

        let dateMatch = true;
        if (fromDate) {
            dateMatch = moment(item.created).isSameOrAfter(moment(fromDate).startOf('day'));
        }
        if (toDate && dateMatch) {
            dateMatch = moment(item.created).isSameOrBefore(moment(toDate).endOf('day'));
        }

        return toolNameMatch && dateMatch;
    });

    const costTemplate = (rowData: any) => {
    return (
      <span>{(rowData.apiCost / 100).toFixed(2)}</span>
    );
  };

    return (
        <>
            <Toast ref={toast} />
            <div className="subscription-main-page">
                <Header pagename="costtracking" />
                <div className="content-wrapper ">
                    <BackgroundVideo />
                    <div className="row  wrapper-main-row mx-auto wrapper-below-div">
                        <div className="col-12">
                            <BillingMiddleHeader />
                        </div>
                        <div className="row main-content-row mx-auto">
                            <div className="col-lg-2 col-md-3 sidebar-col display-for-desktop">
                                <BillingSidebar pagename="costtracking" />
                            </div>

                            <div className="col-lg-10 col-md-12 col-sm-12 main-content-col ">
                                <div className="row history-search-row d-flex  align-items-end text-12 position-relative">
                                    <div className="col-lg-3 col-md-5 col-sm-12 col-12 my-1">
                                        <label className="me-2 mb-1">Services Name</label>{" "}
                                        <Dropdown
                                            value={toolNameSearch}
                                            options={[{ label: "All", value: "All" }, ...toolsNameList]}
                                            onChange={(e) => setToolNameSearch(e.value)}
                                            placeholder="All"
                                            className="finance-company-dropdown input-field"
                                        />
                                    </div>
                                    <div className="col-lg-2  col-md-6 col-sm-6 col-6 my-1 ">
                                        <label className="me-2 mb-1">From Date</label>

                                        <AtkTextField
                                            type="date"
                                            id="datepicker"
                                            className="input-field"
                                            value={fromDate ? moment(fromDate).format("YYYY-MM-DD") : ""}
                                            onChange={e => setFromDate(e.target.value ? new Date(e.target.value) : null)}
                                            placeholder="From Date"
                                        />
                                    </div>
                                    <div className="col-lg-2  col-md-6 col-sm-6 col-6 my-1  ">
                                        <label className="me-2 mb-1">To Date</label>
                                        <AtkTextField
                                            type="date"
                                            id="datepicker"
                                            className="input-field"
                                            value={toDate ? moment(toDate).format("YYYY-MM-DD") : ""}
                                            onChange={e => setToDate(e.target.value ? new Date(e.target.value) : null)}
                                            placeholder="To Date"

                                        />
                                    </div>
                                </div>
                                {loading == true ? (
                                        <div className="d-flex justify-content-center align-items-center mt-5">
                                            <AtkLoader />{" "}
                                        </div>
                                    ) :
                                <div className="col-12 history-table mt-3">

                                    
                                        <DataTable
                                            value={filteredList}
                                            paginator
                                            paginatorTemplate="PrevPageLink PageLinks NextPageLink"
                                            rows={10}
                                            first={currentPage * 10}
                                            onPage={(e: any) => setCurrentPage(e.page)}
                                            totalRecords={filteredList.length}
                                            selectionMode="single"
                                            dataKey="created"
                                            emptyMessage="No data available."
                                        >
                                            <Column
                                                field="created"
                                                header="Transaction Date"
                                                body={(rowData) => {
                                                    const utcDate = moment.utc(rowData.created);
                                                    const localDate = moment(utcDate).local();
                                                    return (
                                                        <>
                                                            <span>{localDate.format("MM/DD/YYYY")}</span> &nbsp; &nbsp;
                                                            <span className="m-0 payment-history-time">
                                                                {localDate.format("hh:mm a").replace("am", "AM").replace("pm", "PM")}
                                                            </span>
                                                        </>
                                                    );
                                                }}
                                            ></Column>
                                            <Column field="toolName" header="Services Name" sortable></Column>
                                            <Column field="status" header="Status" sortable></Column>
                                            <Column field="apiCost" header="Cost Per Usage (USD)" body={costTemplate} sortable></Column>
                                        </DataTable>
                                    </div>
                                    }
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}